export default __webpack_public_path__ + "images/8A.aa069d8.png";